export function objectSort(getter, invert) {
    if(!getter) getter = (el) => el;
    if(invert) {
        return  (a, b) => getter(a) - getter(b);
    }
    else {
        return  (a, b) => getter(b) - getter(a);
    }
}